import { TransactionStatus } from '../service-proxies';


export class UpdateTransactionStatusDto implements IUpdateTransactionStatusDto {
    ids!: number[] | undefined;
    updateTransactionStatus!: TransactionStatus;

    constructor(data?: IUpdateTransactionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.updateTransactionStatus = _data["updateTransactionStatus"];
        }
    }

    static fromJS(data: any): UpdateTransactionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["updateTransactionStatus"] = this.updateTransactionStatus;
        return data; 
    }
}

export interface IUpdateTransactionStatusDto {
    ids: number[] | undefined;
    updateTransactionStatus: TransactionStatus;
}

